import React from "react";
import ListSkills from "./ListSkills";

function Skills() {
  return (
    <div className="py-[80px]" id="skills">
      <div className="text-center mb-[50px]">
        <h1 className="text-3xl lg:text-4xl font-semibold">Skills</h1>
        <p className="lg:text-xl">My Technical Level</p>
      </div>

      <div className="space-y-8 
      md:grid md:grid-cols-2 md:gap-14 md:space-y-0">
        {/* Skill Section-1 */}
        <div
          className="rounded-xl border-2 border-gray-300
        flex flex-col items-center"
        >
          <h1 className="pt-[30px] lg:text-2xl pb-[20px] font-semibold">
            Frontend Developer
          </h1>

          <div className="w-9/12 mx-auto pb-[35px]">
            <ul className="grid grid-cols-2 gap-4 ">
              <ListSkills skill={"HTML"} level={"Intermediate"} />
              <ListSkills skill={"TAILWIND"} level={"Intermediate"} />
              <ListSkills skill={"CSS"} level={"Advanced"} />
              <ListSkills skill={"GIT"} level={"Intermediate"} />
              <ListSkills skill={"JAVASCRIPT"} level={"Intermediate"} />
              <ListSkills skill={"REACT"} level={"Advanced"} />
            </ul>
          </div>
        </div>

        {/* Skill Section-2 */}
        <div
          className="rounded-xl border-2 border-gray-300
        flex flex-col items-center"
        >
          <h1 className="pt-[30px] pb-[20px] lg:text-2xl font-semibold">
            Backend Developer
          </h1>

          <div className="w-9/12 mx-auto pb-[35px]">
            <ul className="grid grid-cols-2 gap-4">
              <ListSkills skill={"Node Js"} level={"Intermediate"} />
              <ListSkills skill={"Python"} level={"Beginner"} />
              <ListSkills skill={"MongoDB"} level={"Intermediate"} />
              <ListSkills skill={"MySql"} level={"Beginner"} />
              <ListSkills skill={"Express"} level={"Intermediate"} />
              <ListSkills skill={"SQL"} level={"Beginner"} />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
